export function assertHasDotAtEnd(sentence: string) {
  if (sentence.endsWith('.')) return sentence
  return sentence + '.'
}

export function truncateFileName(fileName: string, maxLength = 40) {
  if (fileName.length < maxLength) return fileName
  if (maxLength < 25) return fileName.substring(0, maxLength) + '…'
  return `${fileName.slice(0, maxLength - 9)}…${fileName.slice(
    fileName.length - 8
  )}`
}
